import { getUserData } from "../utils";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

// log user actions
export const logUserAction = async (db, auth, action, id, data, logData, version) => {
  const userData = await getUserData(db, auth.currentUser.uid);
  try {
    const logRef = doc(db, 'logs', `${auth.currentUser.uid}-${Date.now()}`);
    const { name, detail, log_data, order } = logActions[action];
    await setDoc(logRef, {
      user: `${userData.name} ${userData.surname}`,
      userId: auth.currentUser.uid,
      role: userData.role,
      action: name,
      detail: id && data ? detail(id, data) : detail(id),
      order: id && order ? order(id) : "No aplica",
      log_data: logData ? log_data(JSON.stringify(logData)) : log_data("Sin data"),
      version: version,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.log(error);
  }
}


// actions
export const logActions = {
  LOG_IN: {
    name: 'Log In',
    detail: (userId) => `Usuario # ${userId}`,
    log_data: (data) => data,
  },
  LOG_OUT: {
    name: 'Log Out',
    detail: (userId) => `Usuario # ${userId}`,
    log_data: (data) => data,
  },
  ADD_ORDER: {
    name: 'Add Order',
    detail: (orderId,serialTime) => `Pedido # ${orderId} / serial creation : ${serialTime} ms`,
    order: (id) => id,
    log_data: (data) => data,
  },
  EDIT_ORDER: {
    name: 'Edit Order',
    detail: (orderId) => `Pedido # ${orderId}`,
    order: (id) => id,
    log_data: (data) => data,
  },
  PAY_ORDER: {
    name: 'Pay Order',
    detail: (orderId) => `Pedido # ${orderId} saldo pagado`,
    order: (id) => id,
    log_data: (data) => data,
  },
  EDIT_STATUS: {
    name: 'Edit Status',
    detail: (orderId, status) => `Pedido # ${orderId} cambio a status ${status}`,
    order: (id) => id,
    log_data: (data) => data,
  },
  ADD_ITEM: {
    name: 'Add Item',
    detail: (orderId, itemRef) => `Item ref # ${itemRef} en pedido # ${orderId}`,
    order: (id) => id,
    log_data: (data) => data,
  },
  EDIT_ITEM: {
    name: 'Edit Item',
    detail: (orderId, itemRef) => `Item ref # ${itemRef} en pedido # ${orderId}`,
    order: (id) => id,
    log_data: (data) => data,
  },
  DELETE_ITEM: {
    name: 'Delete Item',
    detail: (orderId, itemRef) => `Item ref # ${itemRef} en pedido # ${orderId}`,
    order: (id) => id,
    log_data: (data) => data,
  },
  ADD_USER: {
    name: 'Add User',
    detail: (userId) => `Usuario # ${userId}`,
    log_data: (data) => data,
  },
  EDIT_USER: {
    name: 'Edit User',
    detail: (userId) => `Usuario # ${userId}`,
    log_data: (data) => data,
  },
  DELETE_USER: {
    name: 'Delete User',
    detail: (userId) => `Usuario # ${userId}`,
    log_data: (data) => data,
  },
};